/** TextureProgressBar registration: the parser. */
import { nodeRegistry } from '../../../../core/NodeRegistry';
import { parseTextureProgressBar } from './parser';
const textureProgressBarRegistration = {
    typeName: 'TextureProgressBar',
    parser: parseTextureProgressBar,
};
nodeRegistry.register(textureProgressBarRegistration);
export * from './parser';
export * from './types';
//# sourceMappingURL=index.js.map